import { fabric } from "fabric";

export function loadFabricImageFromURL(src: string) {
	return new Promise((resolve) => {
		fabric.Image.fromURL(src, function (img) {
			resolve(img);
		});
	});
}
export function loadImageFromURL(src: string): Promise<HTMLImageElement> {
	return new Promise((resolve, reject) => {
		const image = new Image();
		const isBase64 = src.startsWith("data:image");

		if (!isBase64) {
			image.crossOrigin = "Anonymous";

			// Prevent cache issues (adds ?timestamp only if no query exists)
			const hasQuery = src.includes("?");
			image.src = src + (hasQuery ? `&cb=${Date.now()}` : `?cb=${Date.now()}`);
		} else {
			image.src = src;
		}

		image.onload = () => resolve(image);
		image.onerror = (err) => {
			console.error("Failed to load image:", src, err);
			reject(new Error(`Failed to load image: ${src}`));
		};
	});
}
